import Tools from '@/components/ezuro/workschedule/components/Tools.vue';
import MinutesToText from '@/components/ezuro/common/MinutesToText.vue'

const defaultFilterValues = {
  year: '',
  month: '',
  company_id: [],
  department_id: []
};

export default {
  name: 'Events',
  components: {
    Tools,
    MinutesToText
  },
  props: {
    basePath: {
      type: String,
      default: 'ezuro/schedule'
    }
  },
  data () {
    return {
      loading: true,
      currentReq: null,
      tableItems: [],
      filterValues: this.BasicHelper.cloneObject(defaultFilterValues),
      tableSorting: { item: 'id', direction: 'asc' },
      paging: { limit: 20, page: 1, total: 0, pages: 0 },
      isMounted: false
    };
  },
  computed: {
    baseTransParam () {
      return 'team';
    },
    basePathComp () {
      return this.basePath
    },
    tableHeaders () {
      const headers = [
        { key: 'fullname', label: this.$t('user.birthdays.fullname'), sortable: false },
        { key: 'company_id', label: this.$t('company-structure.company.name'), sortable: false, format: 'formatFromConfig', configKey: 'user_companies', configParam: 'name' },
        { key: 'department_id', label: this.$t('company-structure.department.name'), sortable: false, format: 'formatFunc', funcs: [this.getDepartmentName] },
        { key: 'division_id', label: this.$t('company-structure.division.name'), sortable: false, format: 'formatFunc', funcs: [this.getDivisionName] },
        { key: 'event', label: this.$t('work-schedule.event'), sortable: false },
        { key: 'minutes', label: this.$t('general.total'), sortable: false, type: 'slot', slotcode: 'minutesToText' }
      ];

      const actions = [];
      headers.push({ key: 'actions', label: '', actions, classTd: 'w-10' });

      return headers;
    },
    tableExpandConfig () {
      return null;
    },
    tableFilterConfig () {
      const filters = { };
      return filters;
    },
    canDelete () {
      return true;
    },
    canEdit () {
      return true;
    },
    requestPath () {
      let path = this.ApiRequest.addGetParamsToPath(this.basePathComp + '/report/users?perPage=' + this.paging.limit + '&page=' + this.paging.page, [], true);

      if (this.tableSorting.item) {
        path += '&order=' + this.tableSorting.item + ',' + this.tableSorting.direction;
      }

      return path;
    },
    tableActions () {
      const actions = { download: false };
      return actions;
    }
  },
  methods: {
    getDepartmentName (id) {
      return id ? this.$store.getters.getParamFromConfig('company_departments', id, 'name', this.$i18n.locale) : null;
    },
    getDivisionName (id) {
      return id ? this.$store.getters.getParamFromConfig('company_divisions', id, 'name', this.$i18n.locale) : null;
    },
    getTableData () {
      if (this.basePathComp) {
        if (this.currentReq) {
          this.currentReq.cancel('changed search query');
        }

        this.loading = true;
        this.currentReq = this.ApiRequest.request(this.requestPath, this.ApiRequest.REQUEST_POST, this.filterValues, (response) => {
          if (response.data) {
            this.tableItems = response.data;
            this.paging = response.paging;
            this.loading = false;
          }
        });
      }
    },
    clearFilters () {
      this.filterValues = this.BasicHelper.cloneObject(defaultFilterValues);
      this.getTableData();
    },
    changePage (pageNr) {
      this.paging.page = pageNr;
      this.getTableData();
    },
    updateFilter (key, value) {
      if (this.filterValues[key] !== value) {
        this.filterValues[key] = this.BasicHelper.cloneObject(value);
        this.paging.page = 1;
        this.getTableData();
      }
    },
    filterTools (data) {
      for (const key in data) {
        this.filterValues[key] = data[key];
      }
      this.paging.page = 1;
      this.getTableData();
    },
    tabChanged (el) {
      if (this.tabOptions[el]) {
        this.activeTab = this.tabOptions[el].code;
      }
    }
  },
  mounted () {
    if (!this.typeId) {
      this.filterValues = this.BasicHelper.fillFilterValues(this.$route.name, this.filterValues, this.$session);
    } else {
      this.filterValues.type_id = this.typeId;
    }
    this.getTableData();
    this.isMounted = true;
  },
  watch: {
    basePathComp: {
      immediate: true,
      handler (val) {
        if (val) {
          this.isMounted = false;
          if (!this.typeId) {
            this.filterValues = this.BasicHelper.fillFilterValues(this.$route.name, this.filterValues, this.$session);
          } else {
            this.filterValues.type_id = this.typeId;
          }
          this.getTableData();
          this.isMounted = true;
        }
      }
    }
  }
}
